"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusStore = void 0;
const react_1 = require("react");
const useCirrusStoreGet_1 = require("./useCirrusStoreGet");
const useCirrusStorePut_1 = require("./useCirrusStorePut");
function useCirrusStore(url, _defaultValue = null, options = {}) {
    const get = useCirrusStoreGet_1.useCirrusStoreGet(url, 'application/json', options);
    const [putContent] = useCirrusStorePut_1.useCirrusStorePut('application/json');
    const update = react_1.useCallback((content) => {
        return putContent(url, content);
    }, [putContent, url]);
    return react_1.useMemo(() => [get, { update }], [get, update]);
}
exports.useCirrusStore = useCirrusStore;
//# sourceMappingURL=useCirrusStore.js.map